module.exports = __webpack_public_path__ + "img/Hero@2x.78463a1f.png";